export const ADD_TO_CART_TOAST = 'add-to-cart-toast-container';
export const ADD_TO_EXISTING_EZ_SHIP_TOAST = 'add-to-existing-ez-ship-container';
export const DEFAULT_TOAST = undefined;

export const AUTH_MODAL_TOAST_CONTAINER = 'auth-modal-toast-container';
